import {
  getLeoUuid,
  LeoUUID,
  getUrl,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class GetPresignedDownloadURLForEmailCycleRecipientsRPC implements
  LeoRPC<GetPresignedDownloadURLForEmailCycleRecipientsRPC.Request, GetPresignedDownloadURLForEmailCycleRecipientsRPC.Response, GetPresignedDownloadURLForEmailCycleRecipientsRPC.Errors.Errors>
{
  abstract execute(
    request: GetPresignedDownloadURLForEmailCycleRecipientsRPC.Request
  ): Promise<LeoRPCResult<GetPresignedDownloadURLForEmailCycleRecipientsRPC.Response, GetPresignedDownloadURLForEmailCycleRecipientsRPC.Errors.Errors>>;
}

export namespace GetPresignedDownloadURLForEmailCycleRecipientsRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    scheduleId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetPresignedDownloadURLForEmailCycleRecipientsRPCRequest: boolean = true;
  
    readonly scheduleId: LeoUUID;
  
  
    constructor(
    scheduleId: LeoUUID
    ) {
      this.scheduleId = scheduleId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const scheduleId = getLeoUuid(dto, "scheduleId", InvalidRequestScheduleIdError);
      return new Request(
        scheduleId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          scheduleId: this.scheduleId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetPresignedDownloadURLForEmailCycleRecipientsRPC(scheduleId='${this.scheduleId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    documentURL: string;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetPresignedDownloadURLForEmailCycleRecipientsResponse: boolean = true;
  
    readonly documentURL: URL;
  
  
    constructor(
    documentURL: URL
    ) {
      this.documentURL = documentURL;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const documentURL = getUrl(dto, "documentURL", InvalidResponseDocumentUrlError);
      return new Response(
        documentURL
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          documentURL: this.documentURL.toString()
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetPresignedDownloadURLForEmailCycleRecipients(documentURL='${this.documentURL}')`;
  };
  

  export enum RPCError {
    InvalidScheduleId = "INVALID_SCHEDULE_ID"
  }

  export namespace Errors {
    
    export interface InvalidScheduleIdDTO {
      code: string;
    }
    
    export class InvalidScheduleId extends LeoRPCError<RPCError> {
      readonly isInvalidScheduleId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidScheduleId;
        super(code);
      }
    
    
      toDTO(): InvalidScheduleIdDTO {
        const dto: InvalidScheduleIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidScheduleId.prototype.toString = function toString(): string {
      return `GetPresignedDownloadURLForEmailCycleRecipientsRPC.INVALID_SCHEDULE_ID()`;
    };
    

    export type Errors = InvalidScheduleId;
    export type ErrorsDTO = InvalidScheduleIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidScheduleId:
          return new InvalidScheduleId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestScheduleIdError extends GetPresignedDownloadURLForEmailCycleRecipientsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestScheduleIdError";
  }
}

export class InvalidResponseDocumentUrlError extends GetPresignedDownloadURLForEmailCycleRecipientsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseDocumentUrlError";
  }
}

export class InvalidResponseInvalidScheduleIdError extends GetPresignedDownloadURLForEmailCycleRecipientsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidScheduleIdError";
  }
}

